// extracted by mini-css-extract-plugin
export default {"table":"IpGeolocationModal_table__B8fN8","tableCell":"IpGeolocationModal_tableCell__viVfn"};